import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import type { Page } from '@/lib/api/models';
import { unwrap } from '@/lib/api/request';

export function usePage(slug: string) {
  return useQuery<Page>({
    queryKey: ['page', slug],
    queryFn: () => unwrap(api.GET('/pages/{slug}', { params: { path: { slug } } })),
  });
}
